import { UserRole } from "../permissions";
import { SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import { UnknownSlugWorkaround } from "./spacesBase";
import spaceVS from "./spaceVS";

const spaceInternal: SpaceConfig = {
    ...spaceVS,

    id: SpaceId.Internal,
    displayName: "Visual Studio (Internal)",
    slug: UnknownSlugWorkaround,
    spaceTag: { type: "tag", value: "visual-studio" },
    showNavTo: [UserRole.MicrosoftEmployees, UserRole.MVP],
};

export default spaceInternal;
